import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"
import { IAddHeatmapData, IAdminEditHeatmapData } from "../IApisInterface"

export const adminAddHeatmapScanApi = async (payload: IAddHeatmapData) => {
    const response = await AxiosInstance.post(apiRoutes?.adminAddHeatmapScan, payload)
    return response
}
export const adminEditHeatmapApi = async (payload: IAdminEditHeatmapData) => {
    const response = await AxiosInstance.post(apiRoutes?.adminEditHeatmap, payload)
    return response
}

export const adminDeleteHeatMapApi = async (payload: string[]) => {
    const response = await AxiosInstance.post(apiRoutes?.adminHeatmapDelete, payload)
    return response
}

export const adminReportHeatmapApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.adminReportHeatmap, payload)
    return response
}